import { render } from "./contentNewsList.vue?vue&type=template&id=2a7bc7a1"
import script from "./contentNewsList.vue?vue&type=script&lang=js"
export * from "./contentNewsList.vue?vue&type=script&lang=js"

import "./contentNewsList.vue?vue&type=style&index=0&id=2a7bc7a1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__